import { render, staticRenderFns } from "./EmailList.vue?vue&type=template&id=7d807871&scoped=true&"
import script from "./EmailList.vue?vue&type=script&lang=ts&"
export * from "./EmailList.vue?vue&type=script&lang=ts&"
import style0 from "./EmailList.vue?vue&type=style&index=0&id=7d807871&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d807871",
  null
  
)

export default component.exports